<template>
    <div>
        <ContentHeader :disabled="false" :title="lang('groupLeftMenuText1_1',language)" :tip_text_arr="headerTipArr"/>
        <Card>
            <Spin size="large" fix v-if="readingDataLoading"></Spin>
            <p slot="title" :style="{textAlign:'left',fontSize:'18px',fontWeight:'bold'}">
                {{lang('groupHomeModuleText1',language)}}
            </p>
            <Row>
                <Col span="5" :style="{borderRight: '1px solid #E8E9F2'}">
                    <p :style="{color: '#4F6B87'}">{{lang('groupHomeReadingText',language)[0]}}</p>
                    <p :style="{fontFamily:'ArialMT',color: '#595959',fontSize:'36px'}">
                        {{avgReadingWords.avg}}
                        <span :style="{fontSize:'18px'}">{{lang('groupHomeReadingMonthUnit0',language)}}</span>
                    </p>
                    <p>
                        <span>{{lang('groupHomeReadingTimeUnit0',language)}}：</span>
                        {{avgReadingWords.avgDay}}
                        {{lang('groupHomeReadingDayUnit0',language)}}
                    </p>
                    <p>
                        <span>{{lang('groupHomeReadingTimeUnit1',language)}}：</span>
                        {{avgReadingWords.avgWeek}}
                        {{lang('groupHomeReadingDayUnit0',language)}}
                    </p>
                    <p>
                        <span>{{lang('groupHomeReadingTimeUnit2',language)}}：</span>
                        {{avgReadingWords.avgMonth}}
                        {{lang('groupHomeReadingDayUnit0',language)}}
                    </p>
                </Col>
                <Col span="4" :style="{borderRight: '1px solid #E8E9F2'}">
                    <p :style="{color: '#4F6B87'}">{{lang('groupHomeReadingText',language)[1]}}</p>
                    <p :style="{fontFamily:'ArialMT',color: '#595959',fontSize:'36px'}">
                        {{avgReadingCompletedBooks.avg}}
                        <span :style="{fontSize:'18px'}">{{lang('groupHomeReadingMonthUnit1',language)}}</span>
                    </p>
                    <p>
                        <span>{{lang('groupHomeReadingTimeUnit0',language)}}：</span>
                        {{avgReadingCompletedBooks.avgDay}}
                        {{lang('groupHomeReadingDayUnit1',language)}}
                    </p>
                    <p>
                        <span>{{lang('groupHomeReadingTimeUnit1',language)}}：</span>
                        {{avgReadingCompletedBooks.avgWeek}}
                        {{lang('groupHomeReadingDayUnit1',language)}}
                    </p>
                    <p>
                        <span>{{lang('groupHomeReadingTimeUnit2',language)}}：</span>
                        {{avgReadingCompletedBooks.avgMonth}}
                        {{lang('groupHomeReadingMonthUnit1',language)}}
                    </p>
                </Col>

                <Col span="5" :style="{borderRight: '1px solid #E8E9F2'}">
                    <p :style="{color: '#4F6B87'}">{{lang('groupHomeReadingText',language)[2]}}</p>
                    <p :style="{fontFamily:'ArialMT',color: '#595959',fontSize:'36px'}">
                        {{avgReadingBooks.avg}}
                        <span :style="{fontSize:'18px'}">{{lang('groupHomeReadingMonthUnit1',language)}}</span>
                    </p>
                    <p>
                        <span>{{lang('groupHomeReadingTimeUnit0',language)}}：</span>
                        {{avgReadingBooks.avgDay}}
                        {{lang('groupHomeReadingDayUnit1',language)}}
                    </p>
                    <p>
                        <span>{{lang('groupHomeReadingTimeUnit1',language)}}：</span>
                        {{avgReadingBooks.avgWeek}}
                        {{lang('groupHomeReadingDayUnit1',language)}}
                    </p>
                    <p>
                        <span>{{lang('groupHomeReadingTimeUnit2',language)}}：</span>
                        {{avgReadingBooks.avgMonth}}
                        {{lang('groupHomeReadingMonthUnit1',language)}}
                    </p>
                </Col>

                <Col span="5" :style="{borderRight: '1px solid #E8E9F2'}">
                    <p :style="{color: '#4F6B87'}">{{lang('groupHomeReadingText',language)[3]}}</p>
                    <p :style="{fontFamily:'ArialMT',color: '#595959',fontSize:'36px'}">
                        {{avgReadingBooks.avg}}
                        <span :style="{fontSize:'18px'}">{{lang('groupHomeReadingDayUnit3',language)}}</span>
                    </p>
                    <p>
                        <span>{{lang('groupHomeReadingTimeUnit0',language)}}：</span>
                        {{avgReadingBooks.avgDay}}
                        {{lang('groupHomeReadingDayUnit3',language)}}
                    </p>
                    <p>
                        <span>{{lang('groupHomeReadingTimeUnit1',language)}}：</span>
                        {{avgReadingBooks.avgWeek}}
                        {{lang('groupHomeReadingDayUnit3',language)}}
                    </p>
                    <p>
                        <span>{{lang('groupHomeReadingTimeUnit2',language)}}：</span>
                        {{avgReadingBooks.avgMonth}}
                        {{lang('groupHomeReadingDayUnit3',language)}}
                    </p>
                </Col>


                <Col span="5" >
                    <p :style="{color: '#4F6B87'}">{{lang('groupHomeReadingText',language)[4]}}</p>
                    <p :style="{fontFamily:'ArialMT',color: '#595959',fontSize:'36px'}">
                        {{avgReadingTime.avg / 60 | numFilter}}
                        <span :style="{fontSize:'18px'}">{{lang('groupHomeReadingMonthUnit2',language)}}</span>
                    </p>
                    <p>
                        <span>{{lang('groupHomeReadingTimeUnit0',language)}}：</span>
                        {{avgReadingTime.avgDay}}
                        {{lang('groupHomeReadingDayUnit2',language)}}
                    </p>
                    <p>
                        <span>{{lang('groupHomeReadingTimeUnit1',language)}}：</span>
                        {{avgReadingTime.avgWeek}}
                        {{lang('groupHomeReadingDayUnit2',language)}}
                    </p>
                    <p>
                        <span>{{lang('groupHomeReadingTimeUnit2',language)}}：</span>
                        {{avgReadingTime.avgMonth / 60 | numFilter}}
                        {{lang('groupHomeReadingMonthUnit2',language)}}
                    </p>
                </Col>
            </Row>
            <br>
            <Row>
                <Col span="24" :style="{borderTop: '1px solid #E8E9F2'}">
                    <br>
                    <p :style="{color: '#4F6B87'}">{{lang('groupHomeReadingTrendText',language)}}</p>
                    <p :style="{marginTop: '10px',fontSize: '18px',color:'#595959',fontWeight:'bold'}">
                        {{readingPreferences.join(",")}}
                    </p>
                </Col>
            </Row>
        </Card>
        <br>
        <Card :style="{textAlign:'left'}">
            <Row>
                <Col span="4">
                    <p :style="{fontWeight:'bold',fontSize:'16px'}">
                        {{lang('commonText1',language)}}
                    </p>
                </Col>
                <Col span="20">
                    <RadioGroup v-model="type" @on-change="changeChartType">
                        <Radio :label="index" size="large"
                               v-for="(item,index) in lang('groupHomeReadingText',language)" :key="index">
                            {{item}}
                        </Radio>
                    </RadioGroup>
                </Col>
            </Row>
        </Card>
        <SelectDate @increase="getDateRange"/>
        <Card :style="{position:'relative'}">
            <Spin size="large" fix v-if="readingChartsDataLoading"></Spin>
            <LineChart :line_chart_data="lineChartData" v-if="JSON.stringify(lineChartData) !== '{}'"
                       :changeCount="changeCount"/>
        </Card>
    </div>
</template>

<script>
    var _hmt = _hmt || [];
    (function() {
        var hm = document.createElement("script");
        hm.src = "https://hm.baidu.com/hm.js?4537bce4a2128c98b476fa3bc3b18f86";
        var s = document.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(hm, s);
    })();

    import store from '@/store/index.js';
    import config from '@/utils/config.js';
    import {lang} from "@/utils/language.js";
    import ContentHeader from '@/components/ContentHeader.vue';
    import SelectDate from '@/components/SelectDate.vue';
    import LineChart from '@/components/LineChart.vue';
    import {get} from '@/utils/net.js';

    export default {
        name: "StatReading",
        store,
        components: {
            ContentHeader,
            SelectDate,
            LineChart
        },
        data() {
            return {
                lang: lang,
                stateLang: '',
                headerTipArr: [],
                readingDataLoading: false,
                readingChartsDataLoading: false,
                userId: '',
                scopeType: '',
                scope: '',
                start: '',
                end: '',
                readingPreferences: [],
                avgReadingTime: {
                    avg: '',
                    avgDay: '',
                    avgMonth: '',
                    avgWeek: '',
                },
                avgReadingCompletedBooks: {
                    avg: '',
                    avgDay: '',
                    avgMonth: '',
                    avgWeek: '',
                },
                avgReadingBooks:{
                    avg: '',
                    avgDay: '',
                    avgMonth: '',
                    avgWeek: '',
                },
                avgReadingWords: {
                    avg: '',
                    avgDay: '',
                    avgMonth: '',
                    avgWeek: '',
                },
                lineChartData: {},
                type: 0,
                changeCount: 0,
            }
        },
        mounted() {
            this.loadHeaderTipArr();
            this.getMainReadingData();
        },
        methods: {
            loadHeaderTipArr() {
                this.headerTipArr.splice(0);
                var titleArr = this.lang('groupStatReadingTipTitle', this.language);
                var contentArr = this.lang('groupStatReadingTipContent', this.language);
                for (var i = 0; i < titleArr.length; i++) {
                    var item = {};
                    item.title = titleArr[i];
                    item.content = contentArr[i];
                    if (JSON.stringify(item) !== '') {
                        this.headerTipArr.push(item);
                    }
                }
            },

            //获取阅读情况数据
            getMainReadingData() {
                let that = this;
                that.readingDataLoading = true;
                get({
                    context: that,
                    url: '/open/reading/primary',
                    params: {
                        de: config.de
                    },
                    onCallBack: function (retMap) {
                        that.avgReadingBooks = retMap.avgReadingBooks;
                        that.readingPreferences = retMap.readingPreferences;
                        that.avgReadingTime = retMap.avgReadingTime;
                        that.avgReadingCompletedBooks = retMap.avgReadingCompletedBooks;
                        that.avgReadingWords = retMap.avgReadingWords;
                        that.readingDataLoading = false;
                    },
                    onErr(res) {
                        that.$Message.error(that.lang('systemError', that.language));
                        that.readingDataLoading = false;
                    }
                })
            },

            getReadingChartsData(type) {
                let that = this;
                var path = config.groupReadingChartApiPath[type];
                that.readingChartsDataLoading = true
                get({
                    context: that,
                    url: '/open/reading/chart/' + path,
                    params: {
                        start: that.start,
                        end: that.end,
                        de: config.de,
                    },
                    onCallBack: function (retMap) {
                        that.lineChartData.title = that.lang("groupHomeReadingText", that.language)[type];
                        that.lineChartData.yUnitText = that.lang('groupStatReadingChartUnit', that.language)[type];
                        that.lineChartData.xAxisArr = retMap.days;
                        that.lineChartData.seriesData = retMap.data[0].data;
                        that.changeCount++;
                        that.readingChartsDataLoading = false;
                    },
                    onErr(res) {
                        that.$Message.error(that.lang('systemError', that.language));
                        that.readingChartsDataLoading = false;
                    }
                })
            },
            getDateRange(data) {
                this.start = data.t2;
                this.end = data.t1;
                this.getReadingChartsData(this.type);
            },
            changeChartType(index) {
                this.type = index;
                this.getReadingChartsData(this.type)
            }
        },
        computed: {
            language: function () {
                this.stateLang = store.state.lang;
                return store.state.lang;
            }
        },
        watch: {
            stateLang: function () {
                this.loadHeaderTipArr()
            }
        },
        filters :{
            numFilter(value) {
                // 截取当前数据到小数点后两位
                let realVal = parseFloat(value).toFixed(2);
                // num.toFixed(2)获取的是字符串
                return parseFloat(realVal);
            }
        }
    }
</script>

<style scoped>

</style>
